import type { PublicShopDto } from "@babackapp/private-api-client/types";

type EmailComponentWrapperProps = React.PropsWithChildren<{
  shop: PublicShopDto;
}>;

export function EmailComponentWrapper({
  children,
}: EmailComponentWrapperProps) {
  // const ref = useRef<HTMLIFrameElement | null>(null);

  // const content = useMemo(() => {
  // }, [])

  // useEffect(() => {
  //   if (!ref.current) return;

  //   const iframeDoc = ref.current.contentDocument;
  //   if (!iframeDoc) return;

  //   const mountNode = iframeDoc.body;

  //   const root = createRoot(mountNode);
  //   root.render(
  //     content
  //   );
  // }, []);

  // // Find a way to calculate height ...
  // return <iframe ref={ref} className="w-full h-full" />;

  // const tailwindConfig = useMemo(() => ({
  //   theme: {
  //     extend: {
  //       colors: {
  //         primary:
  //           shop.preferences.customisation["primary-400"] ??
  //           shop.preferences.customisation["primary_400"] ??
  //           "#000000",
  //         secondary: "#f1f5f9",
  //         border: "#e2e8f0",
  //         background:
  //           shop.trackingPreferences?.emailsTheme?.backgroundColor ||
  //           "#f0f0f0",
  //         card:
  //           shop.trackingPreferences?.emailsTheme?.cardColor || "#ffffff",
  //       },
  //     },
  //   },
  // }), [shop])

  // Important note:
  // The Tailwind provider has been removed because it was causing unnecessary
  // rerenders to the wrapped components.
  return <>{children}</>;
}
